
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/reviews/[itemID]",
      function () {
        return require("private-next-pages/product/reviews/[itemID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/reviews/[itemID]"])
      });
    }
  